<template>
    <div>
        <h3>Car insurance &mdash; Full cover</h3>
        <ul>
            <li><svg width="16" height="16" viewBox="0 0 28 28" ><use href="#initio_tick_icon" /></svg>Agreed value</li>
            <li><svg width="16" height="16" viewBox="0 0 28 28" ><use href="#initio_tick_icon" /></svg>Nil excess glass cover</li>
            <li><svg width="16" height="16" viewBox="0 0 28 28" ><use href="#initio_tick_icon" /></svg>Liability for damage to someone else</li>
        </ul>
        <p><a href="#" @click.prevent="toggleModal()">See all policy benefits</a></p>
        <modal
            v-if="this.modalOpen"
            :class="{ 'is-active': modalOpen }"
            v-on:childToParent="toggleModal"
            title="Full cover policy benefits"
            footer="Summary of policy only. Please refer to the policy wording for full details of cover."
        >
          <div class="content">
                <h3 class="title is-6 mb-1">${{ toCurrency(answers['Vehicle.Quote']['vehicle_sum_insured_amount'],0) }} Agreed Value cover for the car</h3>
                <ul class="ticks">
                    <li><svg width="16" height="16" viewBox="0 0 28 28" ><use href="#initio_tick_icon" /></svg>Damage</li>
                    <li><svg width="16" height="16" viewBox="0 0 28 28" ><use href="#initio_tick_icon" /></svg>Fire and Natural Disaster</li>
                    <li><svg width="16" height="16" viewBox="0 0 28 28" ><use href="#initio_tick_icon" /></svg>Theft or Burglary</li>
                </ul>

                <h3 class="title is-6 mb-1">No Excess Cover</h3>
                <ul class="ticks">
                    <li><svg width="16" height="16" viewBox="0 0 28 28" ><use href="#initio_tick_icon" /></svg>Windscreens and Glass</li>
                </ul>

                <h3 class="title is-6 mb-1">Additional Benefits</h3>
                <ul class="ticks">
                  <li><svg width="16" height="16" viewBox="0 0 28 28" ><use href="#initio_tick_icon" /></svg>$750 Accommodation after accident</li>
                  <li><svg width="16" height="16" viewBox="0 0 28 28" ><use href="#initio_tick_icon" /></svg>14 Days Rental Car for $20 per day</li>
                  <li><svg width="16" height="16" viewBox="0 0 28 28" ><use href="#initio_tick_icon" /></svg>$1,000 automatic Trailer Cover</li>
                  <li><svg width="16" height="16" viewBox="0 0 28 28" ><use href="#initio_tick_icon" /></svg>Incorrect Fuel</li>
                  <li><svg width="16" height="16" viewBox="0 0 28 28" ><use href="#initio_tick_icon" /></svg>Child Car Seats</li>
                  <li><svg width="16" height="16" viewBox="0 0 28 28" ><use href="#initio_tick_icon" /></svg>Towing and Road Clearing costs</li>
                  <li><svg width="16" height="16" viewBox="0 0 28 28" ><use href="#initio_tick_icon" /></svg>Temporary Repairs</li>
                  <li><svg width="16" height="16" viewBox="0 0 28 28" ><use href="#initio_tick_icon" /></svg>Keys and Locks cover with $100 excess</li>
                </ul>

                <h3 class="title is-6 mb-1">Liability Protection</h3>
                <ul class="ticks">
                  <li><svg width="16" height="16" viewBox="0 0 28 28" ><use href="#initio_tick_icon" /></svg>$20 million Damage to other Property or People</li>
                  <li><svg width="16" height="16" viewBox="0 0 28 28" ><use href="#initio_tick_icon" /></svg>$10,000 Manslaughter Defence costs</li>
                </ul>
            </div>
        </modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { toCurrency } from '@/helpers/currencyHelper.js'

export default {
  computed: {
    ...mapGetters({
      answers: 'flattenedAnswers'
    })
  },
  methods: {
    toCurrency,
    toggleModal: function () {
        this.modalOpen = ! this.modalOpen;
    }
  },
  data: function () {
      return {
        modalOpen: false
      }
  }
}
</script>